import React from 'react';
import PropTypes from 'prop-types';

import ProductSuggestionsWarning from './product-suggestions-warning';
import VoucherWarning from './voucher-warning';

const { UI } = Mobi2Go;
const { Order } = Mobi2Go;

class PreconfirmationWarning extends React.Component {
    static propTypes = {
        closeModal: PropTypes.func.isRequired,
        isModalOpen: PropTypes.func.isRequired,
    };

    constructor() {
        super();

        this.state = {
            voucher_applied: Order.getVoucherApplied(),
            voucher_will_unapply_on_confirmation: Order.getVoucherWillUnapplyOnConfirmation(),
            voucher_error_message: Order.getVoucherErrorMessage(),
            product_suggestions: Order.getProductSuggestions(),
        };

        Order.bind({
            updateVoucherApplied: voucher_applied =>
                this.setState({ voucher_applied }),
            updateVoucherWillUnapplyOnConfirmation: voucher_will_unapply_on_confirmation =>
                this.setState({ voucher_will_unapply_on_confirmation }),
            updateVoucherErrorMessage: voucher_error_message =>
                this.setState({ voucher_error_message }),
            updateProductSuggestions: product_suggestions =>
                this.setState({ product_suggestions }),
        });
    }

    UNSAFE_componentWillUpdate() {
        if (
            this.props.isModalOpen() &&
            !Order.shouldShowPreconfirmationWarning()
        ) {
            this.props.closeModal(true);

            UI.trigger('progressForward', 'preconfirmation_warning');
        }
    }

    render() {
        if (this.state.product_suggestions.length) {
            return (
                <ProductSuggestionsWarning
                    product_suggestions={this.state.product_suggestions}
                    closeModal={this.props.closeModal}
                />
            );
        }

        if (this.state.voucher_will_unapply_on_confirmation) {
            return (
                <VoucherWarning
                    voucher_applied={this.state.voucher_applied}
                    voucher_error_message={this.state.voucher_error_message}
                    closeModal={this.props.closeModal}
                />
            );
        }

        return null;
    }
}

export default PreconfirmationWarning;
